import { __awaiter } from "tslib";
import { emitConfigurationEvent } from "./emitConfigurationEvent";
/**
 * Send updates to event bus
 * @param event
 * @returns
 */
export function handleConfigurationEvent(event) {
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        // emit configuration event to internal emitter
        dispatch(emitConfigurationEvent(event));
    });
}
//# sourceMappingURL=handleConfigurationEvent.js.map